import {User} from './user';

/**
 * Created by Boris on 14/02/2017.
 */
export class ApplicationBase {
  consumerNo: string;
  applicationType: string;
  locationAddress: string;
  installationNumber: string;
  applicant: User = new User();

  refNum: string;
  methodOfApproval = 'electronic';
  isGuestUser = false;
  sst: string;
  sessionId: string;
  damsApplicationID: string;

  toUpperCase() {
    if (this.refNum) {
      this.refNum = this.refNum.toUpperCase();
    }
    this.applicant.toUpperCase();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-objects/application-base.ts